<app-base-modal
  [title]="'Фото'"
>
  <div class="container">
    <img
      class="image"
      [src]="dialogData.url"
      alt=""
    />
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
